import React from "react";
import { useTranslation } from "react-i18next";
import InfoModal from "../../../../../components/modal/InfoModal";

// Same look as the cart's confirmation popup (cart/_components/CheckoutConfirmationModal)
// so logged-in users see one consistent "confirm before paying" step across pages.
function CheckoutConfirmationModal({ show, onClose, onNext }) {
  const { t } = useTranslation();

  return (
    <InfoModal
      show={show}
      onClose={onClose}
      paddingBody="tw:pt-0 tw:-mt-8 tw:mb-8 tw:mx-8"
      modalSize="tw:max-w-xl"
    >
      <div className="tw:max-h-[70vh]">
        <p className="tw:text-center tw:mt-4 tw:mb-0 tw:!text-[18px] tw:!text[600] tw:!text-[#212529]">
          {t("NewCheckout.ModalConfirmationTitle")}
        </p>
        <p className="tw:text-center tw:mt-2 tw:!text-[#7C7B7B]">
          {t("NewCheckout.ModalConfirmationBody")}
        </p>
        <div className="tw:flex tw:flex-col tw:gap-3 tw:md:flex-row tw:md:gap-2 tw:justify-center tw:mt-6">
          <button
            type="button"
            className="tw:rounded-[0.375rem]! tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-outline-282828 tw:w-full tw:h-[50px] tw:!font-[400]"
            onClick={onClose}
          >
            {t("NewCheckout.ModalConfirmationBack")}
          </button>

          <button
            type="button"
            className="tw:rounded-[0.375rem]! tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-[#d4b055] tw:border-[#d4b055] tw:text-[#4a4a4a] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:w-full tw:h-[50px] tw:!font-[400] tw:!text-[#FFFFFF]"
            onClick={onNext}
          >
            {t("NewCheckout.ModalConfirmationProceed")}
          </button>
        </div>
      </div>
    </InfoModal>
  );
}

export default CheckoutConfirmationModal;
